import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['destination']
  static values = { content: String }

  copy () {
    this.destinationTarget.value = this.contentValue
  }
}
